import React, { Component, Fragment } from 'react';
import SideNav from '../../../components/SideNav';
import Grid from '@material-ui/core/Grid';
import './style.css';



import {email} from '../../../services/api';
let apiEmail = new email();

export default class TelaEmail extends Component {
    //Estados da classe
    constructor(props) {
        super(props);
        this.state = {
          email: "",
        };
        this.handleChange = this.handleChange.bind(this);

    }

    //Metodo handle change do input
    handleChange = evt => {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    //Metodo handle submit do button
    //api.post(`/professional/)`
    handleSubmit = event => {
        event.preventDefault();

        const data = {
            email: this.state.email,
        }
        
        //Patch na api
        //api.post(`/email/professional/sendrecover`, data)
        apiEmail.createProfessionalEmail(data)
            .then(res =>{ 
                //console.log(res);
                //console.log(res.data);
                alert("Iremos enviar uma resposta para o e-mail inserido, com os próximos passos!");
            })

            .catch((error) => {
                // Error 
                if (error.response) {
                    alert("E-mail não cadastrado na Plataforma!");
                    //console.log(error.response.data);
                    //console.log(error.response.status);
                    //console.log(error.response.headers);
                } 

            });
    

    }

    //Render method
    render(){
        return(
            
            <Fragment>
                <SideNav />
               
                <div className="bg-fp-main">
                    <h1 class-name="fonte-deafult">Redefinição de Senha</h1>
                </div>

                <br></br>

                <Grid container spacing={5} direction="row" justify="center" alignItems="center" style={{marginTop: '200px'}}>
                    <Grid item xs={12} align="center">
                        <h2 className="color-destaque">Insira o E-mail com qual você realizou o cadastro</h2>
                        <hr className="line"></hr>
                        <br></br>

                        <form onSubmit={this.handleSubmit} id="forms-OG-Login">
                            <input onChange={this.handleChange} name="email" placeholder="Seu email:" id="OG-Login" />
                            <button  onClick={() => this.handleSubmit} id="OG-Login">Verificar e-mail</button>
                        </form>
                    </Grid>
                </Grid>
            </Fragment>
        )
    }
}


/*

// Validação de email
        let aux = 0;
        for(let i = 0; i < data.email.length;  i++){
            if(data.email[i] !== '@'){
                aux ++;
                console.log(aux);
                if(aux === (data.email.length - 1) ){
                    console.log(data.email.length);
                    console.log(aux);
                    alert("Insira um email válido!");
                }
            }else{
                alert("Email válido");
                break;
            }
        }


 */